import { combineReducers } from "redux";
import basicInfoReducer from "./basicInfoSlice";
import searchReducer from "./searchSlice";
import objectConnectionReducer from "./objectConnectionSlice";
import checkInFormReducer from "./checkInFormSlice";
import checkInNewRevisionReducer from "./checkInNewRevisionSlice";
import checkInStatusReducer from "./checkInStatusSlice";
import recentObjectsReducer from "./recentObjectsSlice";

const checkinReducer = combineReducers({
  basicInfo: basicInfoReducer,
  search: searchReducer,
  objectConnection: objectConnectionReducer,
  checkInForm: checkInFormReducer,
  checkInNewRevision: checkInNewRevisionReducer,
  checkInStatus: checkInStatusReducer,
  recentObjects: recentObjectsReducer,
});

export default checkinReducer;

/** Flatten nested CheckinDocument state so components can keep using state.CheckinDocument.docTitle etc. */
export function selectCheckinFlat(state) {
  const c = state.CheckinDocument;
  if (!c) return {};
  const ro = c.recentObjects;
  const status = c.checkInStatus ?? {};
  return {
    ...c.basicInfo,
    ...c.search,
    ...c.objectConnection,
    ...c.checkInForm,
    ...c.checkInNewRevision,
    ...status,
    recentObjects: ro?.data ?? status.recentObjects ?? [],
    recentObjectsLoading: ro?.loading ?? false,
    recentObjectsError: ro?.error ?? null,
    SearchObjectsAdd: status.SearchObjectsAdd,
    isUploadDisabled: status.isUploadDisabled,
    checkinExistingError: status.checkinExistingError,
    checkinExistingWarning: status.checkinExistingWarning,
  };
}
